module.exports = __webpack_public_path__ + "media/images/user/favicons/icon-196x196-067696299d632b91d58c2e105b0d05ce.png";